module.exports = __webpack_public_path__ + "img/ordMoisturizing1.c2d4d881.jpg";